import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import typeTransaction from "./typeTransaction";
import helpersNumbers from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import SelectDropDown from "../../../partials/content/SelectDropDown";

function AddTransaction() {
  const [amount, setAmount] = useState(250000);
  const [users, setUsers] = useState([]);
  const [userIDSelected, setUserIDSelected] = useState(0);
  const [message, setMessage] = useState();
  const history = useHistory();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  useEffect(() => {
    getAllUser();
  }, []);

  const getAllUser = async () => {
    let users = await sendRequestGetAllUser();
    users = users.map((user) => {
      return {
        id: user.usr_id,
        firstname: user.firstname,
        lastname: user.lastname != undefined ? user.lastname : "",
        charge: user.usr_charge,
        persian_role_name: user.persian_role_name,
      };
    });
    setUsers(users);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllUser = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/all",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data.data;
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }

    changeAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const changeAmount = (number) => {
    setAmount(number);
  };

  const generateOptionTagUsers = (users) => {
    const usersForDropDown = users.map((user) => {
      const label = `
               شماره کاربر : ${helpersNumbers.toPersianNum(user.id)}
              -
             ${user.firstname} ${user.lastname}
             -  موجودی کاربر :
           ${helpersNumbers.toPersianNum(
             helpersNumbers.toFormatFinanceNumber(user.charge)
           )} تومان`;
      return { value: user.id, label: label };
    });

    return (
      <SelectDropDown
        data={usersForDropDown}
        setItemHandler={(newItemSelected) => {
          setUserIDSelected(newItemSelected.value);
        }}
      />
    );
  };

  const sendFrom = async (e) => {
    e.preventDefault();
    const dataForm = getDataFrom();
    if (dataForm == false) {
      return;
    }

    const resultSendRequestAddTransaction = await sendRequestAddTransaction(
      dataForm
    );
    if (resultSendRequestAddTransaction != true) {
      setMessage({
        type_class: "alert alert-danger ",
        text: resultSendRequestAddTransaction.message,
        class_icon: "fa fa-exclamation-triangle",
      });
    }
    history.push("/finance/manage/all-transaction");
  };

  const getDataFrom = () => {
    if (!userIDSelected) {
      setMessage({
        type_class: "alert alert-danger ",
        text: "لطفا کاربر را انتخاب کنید.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    const operate = document.querySelector("#operate").value;
    if (operate == 0) {
      setMessage({
        type_class: "alert alert-danger ",
        text: "لطفا عملیات را انتخاب کنید.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    const reason = document.querySelector("#reason").value;
    if (!reason) {
      setMessage({
        type_class: "alert alert-danger ",
        text: "لطفا دلیل انجام این تراکنش را بنویسید.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let operateString = Object.keys(
      typeTransaction.typeOperateTransaction
    ).find(
      (key) => typeTransaction.typeOperateTransaction[key] === parseInt(operate)
    );
    operateString = operateString.toLowerCase();
    return {
      amount: amount,
      user_id: parseInt(userIDSelected),
      operate: operateString,
      reason: reason,
    };
  };

  const sendRequestAddTransaction = async (data) => {
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/payment/manage/transaction",
        data,
        headersRequest
      );
    } catch (error) {
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return error.response.data.message;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">تراکنش جدید</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    {messageTag}
                    <form>
                      <div class="form-group">
                        <label>مبلغ (تومان)</label>
                        <input
                          type="text"
                          id="amount"
                          class="form-control number-finance"
                          value={helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(amount)
                          )}
                          onChange={inputAmountChangeHandler}
                          onBeforeInput={inputAmountBeforeInputHandler}
                          dir="ltr"
                        />
                      </div>
                      <div class="form-group">
                        <label>کاربر</label>
                        {generateOptionTagUsers(users)}
                      </div>
                      <div class="form-group">
                        <label>نوع تراکنش</label>
                        <select class="form-control" id="operate">
                          <option value={0}>انتخاب کنید</option>
                          {Object.keys(
                            typeTransaction.typeOperateTransaction
                          ).map(function (key, index) {
                            return (
                              <option
                                value={
                                  typeTransaction.typeOperateTransaction[key]
                                }
                              >
                                {
                                  typeTransaction.typeOperateTransactionString()[
                                    typeTransaction.typeOperateTransaction[key]
                                  ]
                                }
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div class="form-group">
                        <label>دلیل خود را از این تراکنش بنویسید </label>
                        <div>
                          <textarea
                            className="form-control"
                            id="reason"
                            rows="5"
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group">
                        <button onClick={sendFrom} className="btn btn-primary">
                          اعمال
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddTransaction;
